// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__2u63U","list":"PatternAutocomplete_list__1oXzd"};